
import React from 'react';
import { DatePicker } from 'antd';
import { Atom, wrap, Wrapper } from 'AppReact';
import styled from 'styled-components';


const PickerWrapper = Wrapper(styled.div`
        border: 1px solid rgb(227, 227, 227);
        border-radius: 8px;
        padding-left: 12px;
        padding-right: 12px;
        box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 2px;

        &:hover {
            border: 1px solid ${window?.settings?.primary_color ?? '#1DBD6B'};
        }
    `)

export const MonthPicker = wrap(
    Atom({ type: 'custom', dataType: 'string', template: DatePicker }),
    PickerWrapper
)
